export const addTrailingSlash = (url: string) => {
  const domain = 'http://example.com'; // The URL class needs a domain to build a URL, but we don't use it later, so it can be anything.
  const fullUrl = new URL(url, domain);
  const pathWithEndSlash = fullUrl.pathname.endsWith('/') ? fullUrl.pathname : `${fullUrl.pathname}/`;
  return `${pathWithEndSlash}${fullUrl.search}`;
};
